import React from 'react';
import { useNavigate } from 'react-router-dom';

export const SubscriptionPrompt = ({ type, title }) => {
  const navigate = useNavigate();
  
  const getSubscriptionDetails = (type) => {
    switch(type) {
      case 'weather':
        return {
          description: 'Get detailed weather forecasts, including METAR and TAF data for your entire route.',
          price: '20.00',
          path: '/subscription/weather'
        };
      case 'notams':
        return {
          description: 'Access comprehensive NOTAM information and regulatory compliance checks.',
          price: '20.00',
          path: '/subscription/notam'
        };
      case 'risk_analysis':
        return {
          description: 'Get detailed risk analysis and safety recommendations for your flights.',
          price: '30.00',
          path: '/subscription/risk'
        };
      default:
        return {
          description: 'Upgrade your subscription to access premium features.',
          price: '20.00',
          path: '/subscription'
        };
    }
  };

  const details = getSubscriptionDetails(type);

  return (
    <div className="p-4 bg-gray-50 rounded-lg border border-gray-200">
      <h4 className="font-medium text-gray-900 mb-2">{title}</h4>
      <p className="text-gray-600 text-sm mb-4">{details.description}</p>
      <div className="flex items-center justify-between mb-4">
        <span className="text-gray-900 font-medium">+ ${details.price} / mo</span>
      </div>
      <button 
        onClick={() => navigate(details.path)}
        className="w-full bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors"
      >
        Add {type.charAt(0).toUpperCase() + type.slice(1)} Subscription
      </button>
    </div>
  );
};

export default SubscriptionPrompt; 